import React from 'react';
import { TToggleButtonProps } from "types/Components/Common/Inputs/ToggleButton"

const ToggleButton = ({
    value = false,
    name = "toggle-button",
    defaultValue,
    disabled,
    onChange,
    id
}: TToggleButtonProps) => {
    return (
            <label id={`${id}`} htmlFor = {name} className="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                <input 
                type="checkbox" 
                checked={value} 
                disabled = {disabled}
                name={name} 
                id={name} 
                onChange={onChange}
                className={`tw-sr-only tw-peer/toggle-button-checkbox`}/>
                <div className={`tw-border-gray tw-border tw-w-11 tw-h-6 tw-bg-lightgray peer-focus/toggle-button-checkbox:tw-outline-none 
                    tw-rounded-full tw-transition-all tw-duration-300 after:tw-duration-300
                    peer-disabled/toggle-button-checkbox:tw-bg-lightgray
                    peer-disabled/toggle-button-checkbox:tw-border-lightgray
                    dark:tw-bg-lightgray peer-checked/toggle-button-checkbox:after:tw-translate-x-full peer-checked/toggle-button-checkbox:after:tw-border-white 
                    peer-checked/toggle-button-checkbox:after:tw-bg-white 
                    after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-shadow-md after:tw-shadow-gray-600
                    after:tw-border-white after:tw-bg-white after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 
                    after:tw-transition-all dark:tw-border-lightgray peer-checked/toggle-button-checkbox:tw-border-[#488328] peer-checked/toggle-button-checkbox:tw-bg-[#488328]`}></div>
            </label>
    )
}

export default ToggleButton